import './style.scss';
import { ButtonProps, ButtonSize, ButtonType, FillType } from 'views/components/atoms/button';
import { BankSearchGojuon } from 'views/components/molecules/bankSearch/bankSearchGojuon';
import { BankSearchText } from 'views/components/molecules/bankSearch/bankSearchText';
import { BankInfoSelect } from 'views/components/molecules/bankSearch/bankSelect';
import { CodeNameMap } from './hooks';
import { useState } from 'react';
import { EstablishError } from 'views/components/atoms/establishes/error';
import { normalizeKatakana } from 'views/utils/format/FormatString';

type BrokerInfoSearchProps = {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  code: string;
  setCode: React.Dispatch<React.SetStateAction<string>>;
  searchGojuon: { getBrokerInfoByGojuon: (brokerNameKana: string) => Promise<void>; isGojuonNoResult: boolean };
  searchKana: { getBrokerInfoByKana: (brokerNameKana: string) => Promise<void>; isKanaNoResult: boolean };
  searchCode: { getBrokerInfoByCode: (brokerCode: string) => Promise<void>; isCodeNoResult: boolean };
};
/**
 * 金融機関名検索
 * @param props
 * @returns
 */
export const BrokerInfoSearch = (props: BrokerInfoSearchProps) => {
  const { name, setName, code, setCode, searchGojuon, searchKana, searchCode } = props;
  const [kanaErrorMessage, setKanaErrorMessage] = useState<string>();
  const [codeErrorMessage, setcodeErrorMessage] = useState<string>();

  // カナ検索のバリデーション
  function validateKana(brokerNameKana: string): boolean {
    const kanaRegex = /^[ァ-ヶー]+$/;
    if (!kanaRegex.test(brokerNameKana)) {
      setKanaErrorMessage('全角カタカナで入力してください');
      return false;
    }
    setKanaErrorMessage(undefined);
    return true;
  }

  // コード検索のバリデーション
  function validateCode(brokerCode: string): boolean {
    const codeRegex = /^\d{4}$/;
    if (!codeRegex.test(brokerCode)) {
      setcodeErrorMessage('4桁の数字で入力してください');
      return false;
    }
    setcodeErrorMessage(undefined);
    return true;
  }
  return (
    <div className="brokerInfoSearchWrapper">
      <div className="brokerInfoSearchWrapper_input">
        <div className="brokerInfoSearchWrapper_Gojuon">
          <BankSearchGojuon
            label="1: 50音で検索"
            onClick={(kana) => {
              searchGojuon.getBrokerInfoByGojuon(kana);
            }}
          />
          <EstablishError isEnabled={searchGojuon.isGojuonNoResult} errorText="該当するデータがありません" />
        </div>
        <div className="brokerInfoSearchWrapper_Text">
          <div className="brokerInfoSearchText">
            <BankSearchText
              inputType="text"
              label="2 : 金融機関名のカナで検索"
              placeholder="例:ミズホ"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onSearch={() => {
                if (!validateKana(name)) return;
                const normalized = normalizeKatakana(name);
                searchKana.getBrokerInfoByKana(normalized);
              }}
            />
            {!!kanaErrorMessage ? (
              <EstablishError isEnabled={!!kanaErrorMessage} errorText={kanaErrorMessage} />
            ) : (
              <EstablishError isEnabled={searchKana.isKanaNoResult} errorText="該当するデータがありません" />
            )}
          </div>
          <div className="brokerInfoSearchText">
            <BankSearchText
              inputType="tel"
              label="3 : 金融機関コードで検索"
              placeholder="例:0001"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onSearch={() => {
                if (!validateCode(code)) return;
                searchCode.getBrokerInfoByCode(code);
              }}
            />
            {!!codeErrorMessage ? (
              <EstablishError isEnabled={!!codeErrorMessage} errorText={codeErrorMessage} />
            ) : (
              <EstablishError isEnabled={searchCode.isCodeNoResult} errorText="該当するデータがありません" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

type BranchSearchProps = {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  code: string;
  setCode: React.Dispatch<React.SetStateAction<string>>;

  searchGojuon: { getBranchInfoByGojuon: (brokerNameKana: string) => Promise<void>; isGojuonNoResult: boolean };
  searchKana: { getBranchInfoByKana: (brokerNameKana: string) => Promise<void>; isKanaNoResult: boolean };
  searchCode: { getBranchInfoByCode: (brokerCode: string) => Promise<void>; isCodeNoResult: boolean };
  onClickPrev: () => void;
};
/**
 * 支店名検索
 * @param props
 * @returns
 */
export const BrokerBranchInfoSearch = (props: BranchSearchProps) => {
  const { name, setName, code, setCode, searchGojuon, searchKana, searchCode, onClickPrev } = props;
  const [kanaErrorMessage, setKanaErrorMessage] = useState<string>();
  const [codeErrorMessage, setcodeErrorMessage] = useState<string>();

  // カナ検索のバリデーション
  function validateKana(brokerNameKana: string): boolean {
    const kanaRegex = /^[ァ-ヶー]+$/;
    if (!kanaRegex.test(brokerNameKana)) {
      setKanaErrorMessage('全角カタカナで入力してください');
      return false;
    }
    setKanaErrorMessage(undefined);
    return true;
  }

  // コード検索のバリデーション
  function validateCode(brokerCode: string): boolean {
    const codeRegex = /^\d{3}$/;
    if (!codeRegex.test(brokerCode)) {
      setcodeErrorMessage('3桁の数字で入力してください');
      return false;
    }
    setcodeErrorMessage(undefined);
    return true;
  }

  return (
    <div className="brokerInfoSearchWrapper">
      <div className="brokerInfoSearchWrapper_input">
        <div className="brokerInfoSearchWrapper_Gojuon">
          <BankSearchGojuon
            label="1: 50音で検索"
            onClick={(kana) => {
              searchGojuon.getBranchInfoByGojuon(kana);
            }}
          />
          <EstablishError isEnabled={searchGojuon.isGojuonNoResult} errorText="該当するデータがありません" />
        </div>
        <div className="brokerInfoSearchWrapper_Text">
          <div className="brokerInfoSearchText">
            <BankSearchText
              inputType="text"
              label="2 : 支店名のカナで検索"
              placeholder="例:トウキョウ"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onSearch={() => {
                if (!validateKana(name)) return;
                const normalized = normalizeKatakana(name);
                searchKana.getBranchInfoByKana(normalized);
              }}
            />
            {!!kanaErrorMessage ? (
              <EstablishError isEnabled={!!kanaErrorMessage} errorText={kanaErrorMessage} />
            ) : (
              <EstablishError isEnabled={searchKana.isKanaNoResult} errorText="該当するデータがありません" />
            )}
          </div>
          <div className="brokerInfoSearchText">
            <BankSearchText
              inputType="tel"
              label="3 : 支店コードで検索"
              placeholder="例:001"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onSearch={() => {
                if (!validateCode(code)) return;
                searchCode.getBranchInfoByCode(code);
              }}
            />
            {!!codeErrorMessage ? (
              <EstablishError isEnabled={!!codeErrorMessage} errorText={codeErrorMessage} />
            ) : (
              <EstablishError isEnabled={searchCode.isCodeNoResult} errorText="該当するデータがありません" />
            )}
          </div>
        </div>
      </div>
      <div className="brokerInfoSearchWrapper_backLink" onClick={() => onClickPrev()}>
        もどる
      </div>
    </div>
  );
};

type BrokerInfoSelectProps = {
  brokerInfoList: CodeNameMap[];
  setBrokerInfo: React.Dispatch<React.SetStateAction<CodeNameMap>>;
  back: () => void;
  next: () => void;
};
export const BrokerInfoSelect = (props: BrokerInfoSelectProps) => {
  const { brokerInfoList, setBrokerInfo, back, next } = props;
  const [isSelected, setIsSelected] = useState<boolean>(false);

  const nextBtnProps: ButtonProps = {
    label: '選択',
    type: ButtonType.Button,
    fillType: FillType.primaryFill,
    buttonSize: ButtonSize.sizeXS,
    onClick: next,
    disabled: !isSelected,
  };
  return (
    <BankInfoSelect
      brokerInfoList={brokerInfoList}
      onSelected={(item) => {
        setBrokerInfo(item);
        setIsSelected(true);
      }}
      onClickPrev={back}
      nextBtnProps={nextBtnProps}
    />
  );
};
